<template>
  <div
    class="col-12 d-flex justify-content-center align-items-center flex-column"
  >
    <div class="row">
      <template v-if="step === 1">
        <div class="col-12 col-md-12 mt-2">
          <button
            @click="_selectService('club')"
            class="btn btn-block btn-payment btn-dark"
          >
            <h3>Business Club</h3>
          </button>
        </div>
        <div class="col-12 col-md-12 mt-2">
          <button
            @click="_selectService('lupe_token')"
            class="btn btn-block btn-payment btn-dark"
          >
            <h3>Lupe Token</h3>
          </button>
        </div>
        <div class="col-12 col-md-12 mt-2">
          <button
            @click="_selectService('lupe_lotto')"
            class="btn btn-block btn-payment btn-dark"
          >
            <h3>Lupe Lotto</h3>
          </button>
        </div>
      </template>
      <template v-else>
        <div class="col-12 col-md-12 mt-2">
          <button
            @click="() => $emit('selected', 16)"
            class="btn btn-block btn-payment btn-dark"
          >
            <cryptoicon :symbol="'usdt'" class="btn-img" />
            <h3>USDT <br /><small class="text-muted">(TRON)</small></h3>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-payment {
  background: unset;
}
.btn-img {
  height: 12rem !important;
  width: 12rem !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>

<script>
export default {
  name: "payment-method",
  data() {
    return { step: 1 };
  },
  beforeDestroy() {
    this.reset();
  },
  methods: {
    _selectService(service) {
      this.$emit("service", service);
      this.$emit("title", "2. Select a payment method to continue");

      this.step = 2;
    },
    reset() {
      this.step = 1;
    },
  },
};
</script>
